import {Subscription} from "../../Context/Dictionaries/api";

export const sortByDuration = (a: Subscription, b: Subscription) => a.duration - b.duration;
